export default "__VITE_PUBLIC_ASSET__2c7365ac__"